"use strict";
/**
 * @module Diffusion
 */
Object.defineProperty(exports, "__esModule", { value: true });
var session_metric_collector_builder_1 = require("./../features/metrics/session-metric-collector-builder");
var topic_metric_collector_builder_1 = require("./../features/metrics/topic-metric-collector-builder");
var remote_server_builder_1 = require("./../features/remote-servers/remote-server-builder");
var branch_mapping_table_builder_1 = require("./../features/session-trees/branch-mapping-table-builder");
var require_non_null_1 = require("./../util/require-non-null");
var util = require("./../util/string");
/**
 * Inserts an escape character '\' before any of the special characters ' "
 * or \. Additionally checks that the string is defined.
 *
 * @param s  the string to be escaped
 * @returns  the string value with escape characters inserted as appropriate
 * @throws   an error if the argument is `null` or `undefined`
 */
function escape(s) {
    return util.escape(require_non_null_1.requireNonNull(s, 'string'));
}
exports.escape = escape;
/**
 * Converts a formatted multi value property to a set of roles.
 * Additionally checks that the string is defined.
 *
 * Unescapes any escaped characters in the string.
 * @param s  the string with quoted substrings separated by whitespace or
 *           commas
 * @return   set of strings
 * @throws   an error if the argument is `null` or `undefined`
 */
function stringToRoles(s) {
    return util.stringToSet(require_non_null_1.requireNonNull(s, 'string'));
}
exports.stringToRoles = stringToRoles;
/**
 * Converts a set of roles to a canonicalised property string
 * representation, escaping as required.
 *
 * Uses comma separators and single quotes.
 *
 * @param roles  a set of strings
 * @return       a string with each of the members escaped, quoted and concatenated
 * @throws       an error if the argument is `null` or `undefined`
 */
function rolesToString(roles) {
    return util.collectionToString(require_non_null_1.requireNonNull(roles, 'roles'));
}
exports.rolesToString = rolesToString;
/**
 * Create a new {@link BranchMappingTableBuilder}.
 *
 * @since 6.7
 */
function newBranchMappingTableBuilder() {
    return new branch_mapping_table_builder_1.BranchMappingTableBuilderImpl();
}
exports.newBranchMappingTableBuilder = newBranchMappingTableBuilder;
/**
 * Create a new {@link SessionMetricCollectorBuilder}.
 *
 * @since 6.7
 */
function newSessionMetricCollectorBuilder() {
    return new session_metric_collector_builder_1.SessionMetricCollectorBuilderImpl();
}
exports.newSessionMetricCollectorBuilder = newSessionMetricCollectorBuilder;
/**
 * Create a new {@link TopicMetricCollectorBuilder}.
 *
 * @since 6.7
 */
function newTopicMetricCollectorBuilder() {
    return new topic_metric_collector_builder_1.TopicMetricCollectorBuilderImpl();
}
exports.newTopicMetricCollectorBuilder = newTopicMetricCollectorBuilder;
/**
 * Create a new {@link RemoteServerBuilder}.
 *
 * @since 6.7
 */
function newRemoteServerBuilder(selectors) {
    return new remote_server_builder_1.RemoteServerBuilderImpl(selectors);
}
exports.newRemoteServerBuilder = newRemoteServerBuilder;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/diffusion/diffusion-globals.js
// module id = 1443
// module chunks = 1